module.exports = __webpack_public_path__ + "static/media/playstore-5b.68088196.png";